<div class="header-container d-flex">
  <div
    *ngIf="!isMobile"
    class="header-logo d-flex justify-content-between align-items-center"
    [ngClass]="{ 'hide-sidebar': !sidebarVisible }"
  >
    <div></div>
    <a id="logo" routerLink="/">
      <img
        src="/assets/icons/SCGC_4C_logo_3889x1963px.png"
        height="63"
        class="d-inline-block align-top"
        alt=""
        loading="lazy"
      />
    </a>
    <p-button
      *ngIf="!isMobile"
      [icon]="sidebarVisible ? 'bi bi-text-indent-right' : 'bi bi-text-indent-left'"
      styleClass="p-button-rounded p-button-secondary p-button-text align-self-center btn-berger text-black"
      (onClick)="onClickToggleSidebar()"
    ></p-button>
  </div>
  <div
    *ngIf="isMobile"
    class="header-logo-mobile align-items-center align-self-center"
  >
    <p-button
      icon="pi pi-bars"
      styleClass="p-button-rounded p-button-secondary p-button-text align-self-center text-black"
      (onClick)="onClickToggleSidebar()"
    ></p-button>
  </div>
  <div class="d-flex justify-content-between align-items-center w-100">
    <div class="header-app-name p-l-10">
      <span class="full-app-name">
        <span *ngIf="version" class="text-env">[{{ version }}]</span>
        {{ isMobile ? APP_NAME_SHORT : APP_NAME }}
      </span>
    </div>
    <div class="header-user-data m-r-10">
      <p-button
        [label]="isMobile ? userShortName : userFullName"
        icon="pi pi-user"
        styleClass="p-button-rounded align-self-center p-button-outlined btn-user"
        (click)="op.toggle($event)"
      ></p-button>
    </div>
  </div>
</div>

<p-overlayPanel #op styleClass="user-menu-panel">
  <ng-template pTemplate="content">
    <p-menu #menu [model]="menuItems" styleClass="user-menu"></p-menu>
  </ng-template>
</p-overlayPanel>
